export default "__VITE_ASSET__DT3t0WbD__"